module.exports = __webpack_public_path__ + "img/lan-right.eedda682.png";